import type { AdminFilterOption } from './organizationFilters';

export const INTEGRATION_TYPE_FILTERS: AdminFilterOption[] = [
  { value: 'meta_ads', label: 'Meta Ads' },
];

export const INTEGRATION_STATUS_FILTERS: AdminFilterOption[] = [
  { value: 'connected', label: 'Conectado' },
  { value: 'disconnected', label: 'Desconectado' },
];

export const INTEGRATION_EXPIRING_FILTERS: AdminFilterOption[] = [
  { value: 'yes', label: 'Expira em ≤7 dias' },
  { value: 'no', label: 'Sem expiração próxima' },
];

export type AdminIntegrationFilters = {
  type: string;
  status: string;
  expiringSoon: string; // '' | 'yes' | 'no'
};

export const EMPTY_INTEGRATION_FILTERS: AdminIntegrationFilters = {
  type: '',
  status: '',
  expiringSoon: '',
};

export function integrationStatusLabel(status: string | null | undefined): string {
  if (!status) return '—';
  return (
    INTEGRATION_STATUS_FILTERS.find((o) => o.value === status)?.label ??
    status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

export function integrationTypeLabel(type: string | null | undefined): string {
  if (!type) return '—';
  return (
    INTEGRATION_TYPE_FILTERS.find((o) => o.value === type)?.label ??
    type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}
